// {/* <TableHead sx={{ backgroundColor: "#dcdede" }}> */}

import {
    Box,
    Chip,
    CircularProgress,
    InputAdornment,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Fade,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import api from "../../services/api";
import Date from "../../utils/date";
import ListaVazia from "../../utils/listaVazia";
import HeaderSession from "../../utils/headerSession";
import FerramentaNavegacaoExportacao from "../../utils/paginacao";

export default function ListReclamacoes() {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const [reclamacoes, setReclamacoes] = useState([]);
    const [configLista, setConfigLista] = useState({});
    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(
        Number(searchParams.get("page")) || 1
    );

    const [perPage, setPerPage] = useState(50);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("Análise");
    const departamento = searchParams.get("departamento") || "";

    useEffect(() => {
        buscarReclamacoes();
    }, [page, status, perPage]);

    const buscarReclamacoes = async () => {
        try {

            setLoading(true);

            const response = await api.get(
                `/reclamacoes?status=${status}&page=${page}&perPage=${perPage}&departamento=${departamento}`
            );

            setReclamacoes(response?.data?.reclamacoes || []);
            setConfigLista(response?.data || {});

        } catch (error) {

            console.error("Erro ao buscar reclamações:", error);

        } finally {

            setLoading(false);
        }
    };

    const reclamacoesFiltradas = useMemo(() => {

        return reclamacoes.filter((item) =>
            item?.nome?.toLowerCase().includes(search.toLowerCase()) ||
            item?.assunto?.toLowerCase().includes(search.toLowerCase()) ||
            item?.tel?.toLowerCase().includes(search.toLowerCase())
        );

    }, [reclamacoes, search]);

    const getStatusColor = (status) => {

        switch (status) {

            case "Concluído":
                return "success";

            case "Análise":
                return "warning";

            default:
                return "default";
        }
    };

    return (
        <Box>
            <HeaderSession title="LISTA DE RECLAMAÇÕES, SUGESTÕES E DENUNCIAS" />

            {/* FILTROS */}
            <Paper
                elevation={2}
                sx={{
                    p: 2,
                    mb: 3,
                    borderRadius: 1,
                    display: "flex",
                    gap: 2,
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >

                {/* PESQUISA */}
                <TextField
                    fullWidth
                    placeholder="Pesquisar por nome, assunto ou telefone..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{
                        flex: 1,
                        minWidth: 250,
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />

                {/* STATUS */}
                <TextField
                    select
                    label="Estado"
                    size="medium"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    sx={{
                        width: 220,
                    }}
                >
                    <MenuItem value="Análise">
                        Em análise
                    </MenuItem>

                    <MenuItem value="Concluído">
                        Já respondidos
                    </MenuItem>
                </TextField>

            </Paper>

            {/* LOADING */}
            {loading ? (

                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight="40vh"
                >
                    <CircularProgress />
                </Box>

            ) : reclamacoesFiltradas.length > 0 ? (

                <Fade in timeout={400}>

                    <TableContainer
                        component={Paper}
                        elevation={3}
                        sx={{ borderRadius: 1, overflow: "hidden", }}>

                        <Table>
                            {/* HEAD */}
                            <TableHead>

                                <TableRow
                                    sx={{ background: "#dcdede", color: "#000" }} >

                                    <TableCell align="center">
                                        <Typography
                                            fontWeight="bold"
                                            color="#000"
                                        >
                                            Nome
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center">
                                        <Typography
                                            fontWeight="bold"
                                            color="#000"
                                        >
                                            Assunto
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center">
                                        <Typography
                                            fontWeight="bold"
                                            color="#000"
                                        >
                                            Telefone
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center">
                                        <Typography
                                            fontWeight="bold"
                                            color="#000"
                                        >
                                            Data
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center">
                                        <Typography
                                            fontWeight="bold"
                                            color="#000"
                                        >
                                            Estado
                                        </Typography>
                                    </TableCell>

                                </TableRow>

                            </TableHead>

                            {/* BODY */}
                            <TableBody>

                                {reclamacoesFiltradas.map((reclamacao) => (

                                    <TableRow
                                        key={reclamacao._id}
                                        hover
                                        onClick={() =>
                                            navigate(
                                                `/admin/reclamacao/${reclamacao._id}`
                                            )
                                        }
                                        sx={{
                                            cursor: "pointer",
                                            transition: ".3s",

                                            "&:hover": {
                                                backgroundColor:
                                                    "#f6f0fb",
                                            },
                                        }}
                                    >

                                        <TableCell>
                                            <Typography fontWeight="600">
                                                {reclamacao?.nome}
                                            </Typography>
                                        </TableCell>

                                        <TableCell>
                                            <Typography>
                                                {reclamacao?.assunto}
                                            </Typography>
                                        </TableCell>

                                        <TableCell align="center">
                                            <Typography>
                                                {reclamacao?.tel}
                                            </Typography>
                                        </TableCell>

                                        <TableCell align="center">
                                            <Typography>
                                                <Date
                                                    date={
                                                        reclamacao?.createdAt
                                                    }
                                                />
                                            </Typography>
                                        </TableCell>

                                        <TableCell align="center">

                                            <Chip
                                                label={
                                                    reclamacao?.status
                                                }
                                                color={getStatusColor(
                                                    reclamacao?.status
                                                )}
                                                variant="filled"
                                            />

                                        </TableCell>

                                    </TableRow>
                                ))}

                            </TableBody>

                        </Table>

                        {/* PAGINAÇÃO */}
                        <FerramentaNavegacaoExportacao
                            configLista={configLista}
                            lista={reclamacoesFiltradas}
                            page={page}
                            setPage={setPage}
                            setPerPage={setPerPage}
                        />

                    </TableContainer>

                </Fade>

            ) : (

                <ListaVazia
                    icon={
                        <WarningAmberIcon
                            sx={{
                                fontSize: 70,
                                color: "#999",
                            }}
                        />
                    }
                    titulo="Nenhuma reclamação encontrada"
                    subtitulo="Tente alterar os filtros ou realizar uma nova pesquisa."
                />

            )}

        </Box>
    );
}